import React from 'react'
import { compose } from 'recompose'
import { routesByValue } from 'helpers/routesConstant'
import withViewAllPage from 'hocs/extends/withViewAllPage'
import AwesomeTable from 'components/Table/AwesomeTable'
import MoreAction from 'components/MoreAction'

const ViewAllPages = compose(
  withViewAllPage({
    resourceName: {
      singular: 'categoryBanner',
      plural: 'categoryBanners',
    },
  }),
)(
  ({
    categoryBanners,
    router,
    onOpenTempState,
    renderAddResourceButton,
    deleteCategoryBanner,
    deleteCategoryBannerStatus,
  }) => {
    const config = [
      {
        headerLabel: 'Name',
        accessor: 'categoryName',
        sortable: true,
        width: '65%',
      },
      {
        headerLabel: 'Last Updated',
        accessor: 'lastUpdated',
        isDate: true,
        sortable: true,
        width: '20%',
      },
      {
        width: '15%',
        renderCell: ({ rowData }) => (
          <MoreAction.Default
            grey
            onEdit={() => router.push(routesByValue.editCategoryBanner.getRoute(rowData.id))}
            onDelete={() => onOpenTempState({
              action: () => deleteCategoryBanner(rowData.id),
              content: `Delete ${rowData.name} ?.`,
            })}
          />
        ),
        cellProps: {
          className: 'more-actions',
        },
      },
    ]
    return (
      <AwesomeTable
        defaultSortKey={'name'}
        defaultSortType={'asc'}
        rawData={categoryBanners}
        config={config}
        loading={deleteCategoryBannerStatus.isRequest}
      >
        {renderAddResourceButton()}
      </AwesomeTable>
    )
  },
)

ViewAllPages.propTypes = {}
ViewAllPages.defaultProps = {}

export default ViewAllPages



// WEBPACK FOOTER //
// ./src/pages/Banners/children/CategoryBanners/ViewAllCategoryBanners.js